import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react"
import { FulfillmentTypes } from "@jackfruit/common"
import React from "react"
import { FaCheck } from "react-icons/fa6"
import { IoStorefrontOutline } from "react-icons/io5"
import { PiPackageLight } from "react-icons/pi"
import { BLACK, WHITE } from "../blocks/FulfillmentBlockDarkBlack"
import { FulfillmentConfig } from "./CardButtonWrapperV2"

interface Props {
  config: FulfillmentConfig
  fulfillmentType: FulfillmentTypes
  isSelected: boolean
  onSetChoice: (fulfillment: FulfillmentTypes) => void
  isDisabled?: boolean
}

const BUTTON_ACTIVE_COLOR_DESKTOP = "#ffffff1a"

const CardButtonV2: React.FC<Props> = ({
  config,
  onSetChoice,
  isSelected,
  fulfillmentType,
  isDisabled = false,
}) => {
  const { title, description, icon } = config

  const showDefaultPickupIcon = !icon && fulfillmentType === "pickup"
  const showDefaultDeliveryIcon = !icon && fulfillmentType === "delivery"
  const noDescription = !Boolean(description)

  return (
    <Button
      id={`p-fulfillment-${fulfillmentType}`}
      w="100%"
      px={4}
      py={6}
      borderRadius="lg"
      display={{ base: "none", md: "block" }}
      height="auto"
      textAlign="left"
      whiteSpace="normal"
      color={WHITE}
      bg={isSelected ? BUTTON_ACTIVE_COLOR_DESKTOP : "transparent"}
      onClick={() => onSetChoice(fulfillmentType)}
      isDisabled={isDisabled}
      _hover={{ bg: BUTTON_ACTIVE_COLOR_DESKTOP }}
      border={`1px solid ${isSelected ? WHITE : "#4A5568"}`}
    >
      <Stack direction="row" spacing={4}>
        <Container
          p="0"
          flex="0 0 20px"
          marginTop="2px"
          {...(noDescription && { alignSelf: "center" })}
        >
          {icon && <Box dangerouslySetInnerHTML={{ __html: icon }} />}
          {showDefaultPickupIcon && (
            <IoStorefrontOutline size={noDescription ? "32px" : "20px"} />
          )}
          {showDefaultDeliveryIcon && (
            <PiPackageLight size={noDescription ? "32px" : "20px"} />
          )}
        </Container>
        <Container p="0" {...(noDescription && { alignSelf: "center" })}>
          <Heading
            as="h4"
            fontSize="xl"
            marginBottom={noDescription ? 0 : 2}
            color={WHITE}
          >
            {title}
          </Heading>
          <Text opacity=".75" lineHeight="base" color={WHITE}>
            {description}
          </Text>
        </Container>
        <Container height="32px" width="32px" p="0" flex="0 0 32px">
          {isSelected && (
            <Flex
              p="0"
              background={WHITE}
              align="center"
              justifyContent="center"
              borderRadius="full"
              h="100%"
            >
              <FaCheck color={BLACK} size="20px" />
            </Flex>
          )}
        </Container>
      </Stack>
    </Button>
  )
}

export default CardButtonV2
